import { useTheme } from '../../context/ThemeContext';

const Input = ({ label, ...props }) => {
  const { dark } = useTheme();
  return (
    <div style={{ marginBottom: 14 }}>
      {label && (
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: dark ? '#94A3B8' : '#64748B', marginBottom: 5 }}>
          {label}
        </label>
      )}
      <input {...props} style={{
        width: '100%', padding: '9px 12px', borderRadius: 8,
        border: `1px solid ${dark ? '#475569' : '#D1D5DB'}`,
        background: dark ? '#0F172A' : '#F8FAFC',
        color: dark ? '#F1F5F9' : '#0F172A',
        fontSize: 14, outline: 'none', boxSizing: 'border-box',
        ...(props.style || {}),
      }} />
    </div>
  );
};

export default Input;
